import React, { useState, useMemo, useRef } from 'react';

import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import useSinglePieCharts from '@/pages/intelligence/components/Chart/hooks/useSinglePieCharts';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import type { IChartsIndexInstance } from '@intelligence/components/ChartsComponents/ChartsIndex';

const Visualis: React.FC<any> = (props: any) => {
  const {
    barOrPieData,
    chartType,
    imageType = 'mobile',
    lineData,
    topChartsType = 'streaming-channel',
    segVal,
    gameName,
    segementTitle,
    setChartLoading,
    chartLoading,
    startDate,
    endDate,
    firstWeekSinceReleaseDates,
  } = props;

  // console.log('ChannelsCardVisualisVisualis', props);

  const cardRef = useRef(null);
  const chartsInstance = useRef<IChartsIndexInstance>(null);


  const barNameList = useMemo(() => {
    let nameList: any = [];
    if (Array.isArray(barOrPieData) && barOrPieData?.length > 0) {
      if (Array.isArray(barOrPieData[0].metric_top) && barOrPieData[0].metric_top?.length > 0) {
        barOrPieData[0].metric_top?.map((item: any, i: number): any => {
          nameList.push(item.usrname || '');
        }
        );
      }
    }
    return nameList;
  }, [barOrPieData]);

  const barSeriesData = useMemo(() => {
    let arrList: any = [];
    if (Array.isArray(barOrPieData) && barOrPieData?.length > 0) {
      if (Array.isArray(barOrPieData[0].metric_top) && barOrPieData[0].metric_top?.length > 0) {
        barOrPieData[0].metric_top?.map((item: any, i: number): any => {
          arrList.push({
            type: 'bar',
            name: item.usrname,
            value: item.value ? item.value : 0,
            cover: item.cover,
            itemStyle: {
              color: ECHARTSCOLOR[i],
            },
            label: {
              show: true,
              position: 'top',
              color: '#444',
              distance: 4,
              fontSize: 12,
              formatter: (params: any) => `${newMathFormat(Number(params.value), true)}`,
            }
          });
        }
        );
      }
    }
    return arrList;
  }, [barOrPieData]);

  const barData = useMemo(() => {
    let arrList: any = [];
    if (Array.isArray(barOrPieData) && barOrPieData?.length > 0) {
      if (Array.isArray(barOrPieData[0].metric_top) && barOrPieData[0].metric_top?.length > 0) {
        arrList = barOrPieData[0].metric_top;
      }
    }
    return arrList;
  }, [barOrPieData]);

  const pieSeriesData = useMemo(() => {
    let arrList: any = [];
    if (Array.isArray(barOrPieData) && barOrPieData?.length > 0) {
      if (Array.isArray(barOrPieData[0].metric_top) && barOrPieData[0].metric_top?.length > 0) {
        barOrPieData[0].metric_top?.map((item: any, i: number): any => {
          arrList.push({
            app_id: item.user_id,
            name: item.usrname,
            value: item.value ? item.value : 0,
            cover: item.cover,
          });
        }
        );
      }
    }
    return arrList;
  }, [barOrPieData]);


  // 获取柱状图hooks
  const {
    barOption,
  } = useBarCharts({
    seriesData: barSeriesData,
    setChartLoading,
    barOrPieData: barData,
    barNameList,
    topChartsType,
    cardWidth: cardRef?.current?.clientWidth,
    imageType,
    ifNoBarImg: true,
    titleNow: gameName,
    chartType,
  });

  // 获取饼图hooks
  const {
    pieOption
  } = useSinglePieCharts({
    pieData: pieSeriesData,
    pieTitle: gameName,
    topChartsType,
    setChartLoading,
    chartType,
    chartLoading,
    chartsInstance,
    titleNow: segementTitle,
    startDate,
    endDate,
  });


  //组装rpd折线图数据
  const getRpdTypeData = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    let arr: any = [];
    for (let i in list) {
      arr.push({
        time: list[i].date,
        value: list[i].value,
      });
    }
    return arr;
  };

  const lineSeriesData = useMemo(() => {
    if (!Array.isArray(lineData) || lineData?.length < 1) return [];
    if (!Array.isArray(lineData[0].user_metric_time_line) || lineData[0].user_metric_time_line?.length < 1) return [];
    const lineObj = lineData[0].user_metric_time_line.find((item: any) => item.metric == segVal) || {};
    if (!Array.isArray(lineObj.history) || lineObj.history?.length < 1) return [];
    let arrGameData: any = [];
    for (let n in lineObj.history) {
      const objTemp = {
        id: lineObj.history[n].usrname,
        name: lineObj.history[n].usrname,
        history: getRpdTypeData(lineObj.history[n].date_info || []),
      };
      arrGameData.push(objTemp);
    }
    return {
      source: Array.isArray(arrGameData) ? arrGameData : [],
    };
  }, [lineData, segVal]);
  let lineXAxisData: string[] | undefined;
  if (firstWeekSinceReleaseDates?.length) {
    lineXAxisData = firstWeekSinceReleaseDates;
  }

  // 获取折线图hooks
  const {
    lineOption
  } = useLineCharts({
    lineData: lineSeriesData,
    lineXAxisData,
    metric: 'source',
    topChartsType,
    imageType,
    titleNow: segementTitle,
    chartType,
    setChartLoading,
  });

  return (
    <>
      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          ref={chartsInstance}
          chartLoading={chartLoading}
          lineOption={lineOption}
          chartType={chartType}
          // isNodata={isNodata}
          pieOption={pieOption}
          barOption={barOption}
        />
      </div>
    </>
  );
};

export default Visualis;
